module.exports = __webpack_public_path__ + "static/media/menu-painel.0371ecf9.svg";